import React from 'react';
import { Button, Alert } from 'reactstrap';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import IntlMessages from 'util/IntlMessages';
import { resetRestorePasswordSuccess, restorePassword } from 'actions/Auth';
import { injectIntl, intlShape } from 'react-intl';

class RestorePassword extends React.Component {
	constructor() {
		super();
		this.state = {
			userName: '',
			userNameInvalid: false
		};
	}

	componentDidMount() {
		this.props.resetRestorePasswordSuccess();
	}

	checkInput = () => {
		if (this.state.userName) {
			this.props.restorePassword(this.state.userName);
		} else {
			this.setState({ userNameInvalid: true });
		}
	};

	render() {
		const { userName } = this.state;
		return (
			<div className="app-login-container d-flex justify-content-center align-items-center animated slideInUpTiny animation-duration-3">
				<div className="app-login-main-content">
					<div className="app-logo-content d-flex align-items-center justify-content-center bg-grey">
						<Link className="logo-lg" to="/" title="Jambo">
							<img src="assets/images/icon-meldoo.svg" alt="Meldo-Icon" title="Meldoo" height={100} />
						</Link>
					</div>

					<div className="app-login-content">
						<div className="app-login-header mb-4">
							<h1>
								<IntlMessages id="loginPage.forgotPassword" />
							</h1>
						</div>
						<p>
							<IntlMessages id="restorePasswordPage.info" />
						</p>
						<div className="app-login-form">
							{this.props.restorePasswordSuccess ? (
								<Alert>Success</Alert>
							) : (
								<form>
									<div className="form-group mb-3">
										<input
											placeholder={this.props.intl.formatMessage({ id: 'common.userName' })}
											onChange={event =>
												this.setState({
													userName: event.target.value,
													userNameInvalid: false
												})
											}
											defaultValue={userName}
											className={`form-control form-control-lg ${
												this.state.userNameInvalid ? 'is-invalid' : ''
											}`}
										/>
										<div className="invalid-feedback">
											<IntlMessages id="userProfile.props.userName.invalidText" />
										</div>
									</div>

									<div className="mb-3 d-flex flex-column align-items-start justify-content-between">
										<Button
											onClick={() => {
												this.checkInput(userName);
											}}
											color="primary"
										>
											<IntlMessages id="restorePasswordPage.action" />
										</Button>
									</div>
								</form>
							)}
						</div>
					</div>
				</div>
			</div>
		);
	}
}

const mapStateToProps = ({ auth }) => {
	const { restorePasswordSuccess } = auth;
	return { restorePasswordSuccess };
};

RestorePassword.propTypes = {
	intl: intlShape.isRequired
};

export default connect(
	mapStateToProps,
	{
		resetRestorePasswordSuccess,
		restorePassword
	}
)(injectIntl(RestorePassword));



// WEBPACK FOOTER //
// ./containers/RestorePassword.js